import React from "react";
import styles from "./VoiceListeningState.module.css";
import { AudioVisualizer } from "./AudioVisualizer";
import { useUiCopy } from "../../i18n/useUiCopy";

interface VoiceListeningStateProps {
  className?: string;
  voiceInputState: {
    isListening: boolean;
    isProcessingPunctuation: boolean;
  };
  audioStream?: MediaStream | null;
}

/**
 * VoiceListeningState Component
 *
 * Displays a loading state with animations when voice input is actively recording.
 * Features shimmer background animation, pulsing indicator, and real-time audio visualization.
 */
export const VoiceListeningState: React.FC<VoiceListeningStateProps> = ({
  className = "",
  voiceInputState,
  audioStream,
}) => {
  const copy = useUiCopy();
  const getMessage = () => {
    if (voiceInputState.isProcessingPunctuation) {
      return copy.processing;
    }
    if (voiceInputState.isListening) {
      return copy.recording;
    }
    return copy.processing;
  };

  return (
    <div className={`${styles.voiceListeningState} ${className}`}>
      <div className={styles.voiceListeningIndicator}>
        {/* Show audio visualizer when actively listening, pulse when processing */}
        {voiceInputState.isListening ? (
          <AudioVisualizer isActive={voiceInputState.isListening} audioStream={audioStream} />
        ) : (
          <div className={styles.pulseAnimationContainer}>
            <div className={styles.pulseAnimation} />
          </div>
        )}

        <span className={styles.listeningText}>{getMessage()}</span>
      </div>
    </div>
  );
};
